import {webRequest, webNoTokenRequest} from '../api'

// 新增或更新企業合約設定
export function setContractSetting(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/setContractSetting',
        method:'post',
        data: data
    })
}

// 預覽合約版本
export function getContractSetting() {
    return webRequest({
        url:'/v1/oauth/management/contract/getContractSetting',
        method:'get',
    })
}

// 預覽設定合約資料
export function previewContractSetting(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/previewContractSetting',
        method:'post',
        data: data
    })
}

// 新增編輯租賃住宅管理人員
export function setRentalAgent(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/edit/rentalAgent',
        method:'post',
        data: data
    })
}
// 新增編輯不動產經紀人
export function setEstateAgent(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/edit/estateAgent',
        method:'post',
        data: data
    })
}

// 刪除租賃住宅管理人員
export function delRentalAgent(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/delete/rentalAgent',
        method:'post',
        data: data
    })
}

// 刪除不動產經紀人
export function delEstateAgent(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/delete/estateAgent',
        method:'post',
        data: data
    })
}




// WEBPACK FOOTER //
// ./src/apis/company/contractSetting.js